import { groq } from "next-sanity";
import { getClient } from "../sanity";
import { type Customer, customerFragment } from "./customers";

export type Page = {
  slug: string;
  eyebrow: string;
  title: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  metaImageUrl?: string;
  customers: Customer[];
};

export const getPage = async (slug: string): Promise<Page> => {
  const query = groq`
    *[_type == "page" && slug == "${slug}"] {
      slug,
      eyebrow,
      title,
      description,
      metaTitle,
      metaDescription,
      'metaImageUrl': metaImage.asset->url,
      customers[]->{ ${customerFragment} }
    }
  `;

  const pages = await getClient().fetch(query);
  return pages[0];
};

export type AdsPage = {
  slug: string;
  title: string;
  description: string;
  imageUrl?: string;
  primaryCTA: "signup" | "demo";
  chilipiperRouter?: string;
  metaTitle: string;
  metaDescription?: string;
  metaImageUrl?: string;
};

export const getAdsPage = async (slug: string): Promise<AdsPage | undefined> => {
  const query = groq`
    *[_type == "adsPage" && slug == "${slug}"][0] {
      slug,
      title,
      description,
      'imageUrl': image.asset->url,
      primaryCTA,
      chilipiperRouter,
      metaTitle,
      metaDescription,
      'metaImageUrl': metaImage.asset->url
    }
  `;

  const adsPage = await getClient().fetch(query);
  return adsPage;
};
